import React from 'react';
import EstudiantesCursosCatalog from './EstudiantesCursosCatalog';

export default function EstudiantesCursosPage() {
    return (
        <EstudiantesCursosCatalog />
    );
}
